
const { PixelStreaming,Config,NumericParameters,Flags, OptionParameters,Logger, LogLevel } = require('@epicgames-ps/lib-pixelstreamingfrontend-ue5.7');

const CustomApplication = require('./CustomApplication');
const { isFirefox ,isAndroid, isIOS,} = require ('react-device-detect');
const {EditTextModal} = require ('./EditTextModal');
const { installAdmission, signallingQuery } = require('./admission');
const { installRelayPolicy } = require('./relayPolicy');


let message ;


function uuidv7() {
  const now = BigInt(Date.now());
  const time = now << 16n;

  const rand = (BigInt(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)) << 64n) |
               BigInt(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER));

  let uuid = time | (rand & 0xffffffffffffffffffffffn);

  let hex = uuid?.toString(16).padStart(32, "0");

  return (
    hex.slice(0, 8) + "-" +
    hex.slice(8, 12) + "-7" + hex.slice(13, 16) + "-" +
    ((parseInt(hex[16], 16) & 0x3) | 0x8)?.toString(16) + hex.slice(17, 20) + "-" +
    hex.slice(20)
  );
}

function StreamPixelApplication(settings) {

    let ssUrl;

     let streamerId = settings.streamerId || uuidv7();
     const resX = Number(settings.resX) || 1920;
     const resY = Number(settings.resY) || 1080;

     const ticket = settings.sessionToken;


     // A caller may supply the session id (a pinned test session: the backend minted it and recorded where it
     // must land; signalling takes the id from this URL). Anything else keeps the generated id, as always.
     let sessionId = (typeof settings.sessionId === 'string' && /^[A-Za-z0-9_-]{8,128}$/.test(settings.sessionId))
       ? settings.sessionId
       : `session_${Date.now()}_${Math.floor(Math.random() * 10000)}`;

     // `ticketInUrl: false` (a dedicated deployment's runtime config, P-39): the
     // ticket goes as the first signalling message instead (./admission.js),
     // so it never appears in a URL or an access log. Default: in the URL, as always.
     const ticketInUrl = settings.ticketInUrl !== false;

     ssUrl = "wss://"+settings.signallingHost+"/?"+signallingQuery({
       StreamerId: streamerId,
       ProjectId: settings.appId,
       resX,
       resY,
       SFU_HOST: settings.sfuHost,
       SFU_PLAYER: settings.sfuPlayer,
       sessionId,
     }, { ticket, ticketInUrl });

     const sessionStartMessage = { type: "stream-metadata", sessionId, streamerId };

     window.parent.postMessage(sessionStartMessage, "*");

    const initialSettings = {
        AutoConnect: settings.AutoConnect,
        ss: ssUrl,
        WaitForStreamer: false,
        StreamerId:settings.streamerId,
        TouchInput:true,
        XRControllerInput:settings.xrInput,
      };

    Logger.InitLogging(LogLevel.Warning, true);

    const config = new Config({
       initialSettings,
    }); 


    const browserSupportedCodecs = [];
    let selectedCodec;
                      
    if (!RTCRtpReceiver.getCapabilities) {
        browserSupportedCodecs.push('Only available on Chrome');
        return browserSupportedCodecs;
    }

    const matcher = /(VP\d|H26\d|AV1).*/;
    const codecs = RTCRtpReceiver.getCapabilities('video').codecs;

    codecs.forEach((codec) => {
        const str = codec.mimeType.split('/')[1] + ' ' + (codec.sdpFmtpLine || '');
        const match = matcher.exec(str);
        if (match !== null) {
            browserSupportedCodecs.push(str);
        }
    });

    if (Array.isArray(browserSupportedCodecs) && settings.primaryCodec && settings.fallBackCodec) {
        const pCodeArray = browserSupportedCodecs.filter(item =>
            item.toLowerCase().includes(settings.primaryCodec.toLowerCase())
        );

        const hasAVInPrimary = pCodeArray.some(item => item.toLowerCase().includes("av"));
    
        if (hasAVInPrimary) {
            if (pCodeArray.length > 0 && pCodeArray[0] && pCodeArray[0].length < 6) {
                handleFallback();
            } else if (settings.unrealVersion > 5.3) {
                if (!isFirefox) {
                    config.setOptionSettingOptions("PreferredCodec", pCodeArray);
                }
                config.setOptionSettingValue(OptionParameters.PreferredCodec, pCodeArray[0]);
                selectedCodec = settings.primaryCodec;
            } else {
                handleFallback();
            }
        } else if (pCodeArray.length > 0) {
            if(!isFirefox){
            config.setOptionSettingOptions("PreferredCodec", pCodeArray);
            }
            config.setOptionSettingValue(OptionParameters.PreferredCodec, pCodeArray[0]);
            selectedCodec = settings.primaryCodec;

        } else {
            handleFallback();
        }
    } else {
        console.error("Invalid inputs: Ensure browserSupportedCodecs is an array and settings contain valid codecs.");
    }
    

    function handleFallback() {
        const fCodearray = browserSupportedCodecs.filter(item =>
            item.toLowerCase().includes(settings.fallBackCodec.toLowerCase())
        );
    
        if (fCodearray.length === 0) {
            config.setOptionSettingOptions("PreferredCodec", browserSupportedCodecs);
            selectedCodec = "H264"; 
        } else {
            const hasAVInFallback = fCodearray.some(item => item.toLowerCase().includes("av"));
            
            if (hasAVInFallback) {
                if (fCodearray[0].length < 6) {
                    config.setOptionSettingOptions("PreferredCodec", browserSupportedCodecs);
                    selectedCodec = "H264";  
                } else if (settings.unrealVersion > 5.3) {
                    if (!isFirefox) {
                        config.setOptionSettingOptions("PreferredCodec", fCodearray);
                    }
                    config.setOptionSettingValue(OptionParameters.PreferredCodec, fCodearray[0]);
                    selectedCodec = settings.fallBackCodec;
                } else {
                    config.setOptionSettingOptions("PreferredCodec", browserSupportedCodecs);
                    selectedCodec = "H264";
                }
            } else {
                if (!isFirefox) {
                    config.setOptionSettingOptions("PreferredCodec", fCodearray);
                }
                if (fCodearray.length > 0) {
                    config.setOptionSettingValue(OptionParameters.PreferredCodec, fCodearray[0]);
                    selectedCodec = settings.fallBackCodec;
                } else {
                    selectedCodec = "H264";
                }
            }
        }
    
    }
    
    
    config.setFlagEnabled(Flags.UseCamera,settings.UseCamera);
    config.setFlagEnabled(Flags.ForceTURN,settings.forceTurn);
    config.setFlagEnabled(Flags.MatchViewportResolution,false);
    config.setFlagEnabled(Flags.TouchInput,true);
    config.setFlagEnabled(Flags.FakeMouseWithTouches,settings.fakeMouseWithTouches);
    config.setFlagEnabled(Flags.StartVideoMuted,true);
    config.setFlagEnabled(Flags.BrowserSendOffer,false);
    config.setFlagEnabled(Flags.ForceMonoAudio,false);
    config.setFlagEnabled(Flags.AutoPlayVideo,true);
    config.setFlagEnabled(Flags.HideUI,true);
    config.setFlagEnabled(Flags.WaitForStreamer,true);
    config.setFlagEnabled(Flags.XRControllerInput,settings.xrInput);
    config.setFlagEnabled(Flags.GamepadInput,settings.gamepadInput);
    config.setFlagEnabled(Flags.HoveringMouseMode,settings.hoverMouse);
    config.setFlagEnabled(Flags.MouseInput,settings.mouseInput);
    config.setFlagEnabled(Flags.IsQualityController,true);
    config.setFlagEnabled(Flags.KeyboardInput,settings.keyBoardInput);
    config.setFlagEnabled(Flags.UseMic,settings.useMic);
    config.setFlagEnabled(Flags.AutoEnterVR,true);
    config.setFlagEnabled(Flags.MouseDoubleClickAutoRelease,true);
    // SFU players are passive viewers of a shared stream — they may legitimately
    // watch without interacting, so don't run the AFK timer / disconnect overlay
    // for them. AFK detection stays on for the host / direct (non-SFU) players.
    const isSfuPlayer = settings.sfuPlayer === true || settings.sfuPlayer === 'true';
    // Local dev mode: the developer restarts Unreal constantly and steps away to
    // edit — no AFK kicking, and the player MUST re-poll for the streamer so it
    // attaches when the editor comes up (and re-attaches after every restart).
    const isDevMode = settings.devMode === true || settings.devMode === 'true';
    config.setFlagEnabled(Flags.AFKDetection, !isSfuPlayer && !isDevMode);
    config.setNumericSetting(NumericParameters.WebRTCFPS,60);
    config.setNumericSetting(NumericParameters.MaxQP, 40);
    config.setNumericSetting(NumericParameters.MinQP, 20);
    config.setNumericSetting(NumericParameters.AFKTimeoutSecs, settings.afktimeout);
    config.setNumericSetting(NumericParameters.WebRTCMinBitrate, 100);
    config.setNumericSetting(NumericParameters.WebRTCMaxBitrate, 1000000);
    config.setNumericSetting(NumericParameters.StreamerAutoJoinInterval, 1000);
    // 0 disables the lib's own "wait for streamer" re-poll — dead in production
    // (the server subscribes the player when the app boots). Dev has no server
    // orchestration, so the player itself must keep polling listStreamers until
    // the customer's editor connects.
    config.setNumericSetting(NumericParameters.MaxReconnectAttempts, isDevMode ? 100 : 0);
    config.setNumericSetting(NumericParameters.KeepaliveDelay, 20000);
    const pixelStreaming = new PixelStreaming(config);
    // AutoConnect has already created the WebSocket inside the constructor, but
    // its open event cannot fire before this synchronous code finishes, so the
    // admission message is still the socket's first. Also covers every
    // reconnect: the transport object is reused (see ./admission.js).
    if (!ticketInUrl && !installAdmission(pixelStreaming._webRtcController, ticket)) {
        console.error('StreamPixelApplication: could not install the admission message; signalling will refuse this session (4401).');
    }
    // Forced TURN (FORCE_TURN_ALL): a config whose peerConnectionOptions say iceTransportPolicy 'relay' also turns
    // the lib's ForceTURN rules on, and a 4010 "Relay unavailable" close is terminal (./relayPolicy.js).
    // Dedicated edition only (REACT_APP_EDITION=onprem, compiled out of the SaaS build): SaaS signalling never sends
    // a relay-only config or a 4010, and the SaaS player keeps the library's own close handling untouched.
    if (process.env.REACT_APP_EDITION === 'onprem') installRelayPolicy(pixelStreaming._webRtcController, config, Flags.ForceTURN);



    const uiOptions = {
        stream:pixelStreaming,
         fullScreenControlsConfig:false,
        settingsPanelConfig:{
         visibilityButtonConfig:false
        },
        
    }
  
const appStream = new CustomApplication(uiOptions);

let visibilityTimeout;

// Kept by name so dispose() can remove it: on the dedicated edition a retry after
// streamer loss builds a second application in the same page (App.js
// retryFreshSession), and a listener left behind would still disconnect the OLD
// (already dead) stream 60 s after the tab is hidden. Same handler as before.
let mobileVisibilityHandler = null;
if(isAndroid || isIOS){
mobileVisibilityHandler = function() {
  if (document.hidden) {
    
    visibilityTimeout = setTimeout(() => {
     
      appStream.stream.disconnect();
    }, 60000);
  } else {
    
          if (visibilityTimeout) {
      clearTimeout(visibilityTimeout);
    }
  }
};
document.addEventListener('visibilitychange', mobileVisibilityHandler);
}

     appStream.stream.addEventListener(
        'afkWarningActivate',
        () =>{
             message = {
                "type": "stream-state",
                "value": "afkWarning"
              }
            

            window.parent.postMessage(message, "*");
        }
            
    );

const webRtcPlayer =appStream.stream._webRtcController;

webRtcPlayer.onCommand = (message) => {
    const commandAsString = new TextDecoder('utf-16').decode(message.slice(1));
    const command = JSON.parse(commandAsString);

    if (command.showOnScreenKeyboard === true) {
const datapos = webRtcPlayer.requestUnquantizedAndDenormalizeUnsigned(command.x,command.y);

        const x = datapos.x || 0;
        const y = datapos.y || 0;

        showEditTextModal(command.contents, x, y);
    }
};

  const releaseActiveKeys = () => {
    try {
      const activeKeys = webRtcPlayer.inputClassesFactory.activeKeys.getActiveKeys() || [];
      
      activeKeys.forEach(key => {
        webRtcPlayer.streamMessageController.toStreamerHandlers.get('KeyUp')([key]);
      });

      webRtcPlayer.streamMessageController.toStreamerHandlers.get("MouseLeave")([]);

      const mouseUp = webRtcPlayer.streamMessageController.toStreamerHandlers.get("MouseUp");
  
      if (mouseUp) {
        mouseUp([0, 0, 0]);
        mouseUp([1, 0, 0]);
        mouseUp([2, 0, 0]);
      }

    } catch (err) {
      console.error("Error :", err);
    }
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState !== 'visible') {
      releaseActiveKeys();
    }
  };

  const handleBlur = () => {
    releaseActiveKeys();
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);
  window.addEventListener('blur', handleBlur);

  // Everything this function hung on document/window for THIS stream. App.js
  // calls it (dedicated edition only) before building a fresh application after
  // streamer loss, so the old stream's listeners do not outlive it.
  const dispose = () => {
    if (visibilityTimeout) { clearTimeout(visibilityTimeout); visibilityTimeout = null; }
    if (mobileVisibilityHandler) {
      document.removeEventListener('visibilitychange', mobileVisibilityHandler);
      mobileVisibilityHandler = null;
    }
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.removeEventListener('blur', handleBlur);
  };

let editTextModal = null;

const showEditTextModal = (text, x, y) => {
    if (editTextModal && editTextModal.rootElement) {
        editTextModal.rootElement.remove();
    }

    editTextModal = new EditTextModal();
    const rootElement = document.body;
    rootElement.appendChild(editTextModal.rootElement);

    Object.assign(editTextModal.rootElement.style, {
        top: `45%`
    });

    editTextModal.showModal(text);

    editTextModal.events.addEventListener('editConfirmed', (e) => {
        const confirmedText = e.detail;
        webRtcPlayer.streamMessageController.toStreamerHandlers.get('TextboxEntry')?.([confirmedText]);
    });
};

  
    return {
        pixelStreaming,
        appStream,
        selectedCodec,
        // The id on the signalling URL — what POST /session/end names when the
        // viewer leaves on purpose (App.js endSessionExplicitly, dedicated edition).
        sessionId,
        // Removes this stream's document/window listeners (see above).
        dispose
    };
}

module.exports = { StreamPixelApplication };
